<template>
  <v-tabs
    v-model="active"
    centered
    slider-color="secondary"
    class="v-tabs-reports v-tabs-reports--drawer"
  >
    <v-tab
      v-for="item in ['ride', 'employee']"
      :key="item"
      ripple
      class="pl-0"
      style="width: 50%"
    >
      {{ $t(`${namespace}.${item}`) }}
    </v-tab>

    <v-tab-item>
      <v-card class="pa-4 overflow--y" :style="`height: ${contentHeight}px`" flat>
        <TabRide :data="data" />
      </v-card>
    </v-tab-item>

    <v-tab-item>
      <v-card class="pa-4 overflow--y" :style="`height: ${contentHeight}px`" flat>
        <TabEmployee :data="data" @change="change" />
      </v-card>
    </v-tab-item>
  </v-tabs>
</template>

<script>
import { calcContentHeight } from 'utils/functions'
import TabRide from './TabRide'
import TabEmployee from './TabEmployee'

export default {
  name: 'Tabs',
  props: {
    data: {
      type: Object,
      default: () => {}
    }
  },
  components: {
    TabRide,
    TabEmployee
  },
  data () {
    return {
      namespace: 'Components.GlobalDrawer.reports.tabs',
      active: 0,
      contentHeight: 'none'
    }
  },
  methods: {
    calcContentHeight () {
      this.contentHeight = calcContentHeight() - 65
    },

    change (val) {
      this.$emit('change', val)
    }
  },
  mounted () {
    this.calcContentHeight()
    window.addEventListener('resize', this.calcContentHeight)
  },
  beforeDestroy () {
    window.addEventListener('resize', this.calcContentHeight)
  }
}
</script>

<style lang="scss">
.v-tabs.v-tabs-reports--drawer {

  .v-tabs__container.v-tabs__container--centered {
    margin-left: 0;
  }
}

.name {
  display: block;
  font-family: 'Montserrat', sans-serif;
  font-weight: 800;
  line-height: 1.43;
}

.item__label,
.item__text {
  display: block;
}

.item__label {
  color: $gray-6;
  font-size: 12px;
}
</style>
